import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, needsLenderOnboarding } from '@utils/userUtils';

/**
 * Fallback interception for the lender onboarding screen: when an eligible
 * new broker lands on the dashboard via reload or a direct link (bypassing
 * the login redirect), send them to /welcome/lenders.
 */
export function useRedirectNewBrokerToOnboarding(): void {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const user = await getCurrentUser();
      if (cancelled) return;
      if (user && needsLenderOnboarding(user.lenders, user.lenderBrokers)) {
        navigate('/welcome/lenders', { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);
}
